document.addEventListener("DOMContentLoaded", () => {
    const logo = document.querySelector(".js-cb-logo img");
    if (!logo) return;

    let currentRotation = 0; 
    let targetRotation = 0;

    function animate() {
    // плавне наближення до targetRotation
    currentRotation += (targetRotation - currentRotation) * 0.05;
    logo.style.transform = `rotate(${currentRotation}deg)`;
    requestAnimationFrame(animate);
    }

    window.addEventListener("scroll", () => {
    const rect = logo.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    // відстань від центру екрана
    const elementCenter = rect.top + rect.height / 2;
    const screenCenter = viewportHeight / 2;
    const offset = elementCenter - screenCenter;

    // нормалізація (-1 .. 1)
    const maxOffset = viewportHeight / 2; 
    let factor = offset / maxOffset; 

    if (factor > 1) factor = 1;
    if (factor < -1) factor = -1;

    // 👇 зміна сторін на протилежні
    targetRotation = factor * -60;
    });

    animate();
});